import { motion } from 'framer-motion';
import { imagePath, SERVICE_ACCENT_FILES } from '../config/siteImages';

const services = [
  {
    name: 'Steel Fabrication',
    desc: 'We are experienced steel fabricators based in London, working on projects of all sizes and complexity.\nOur team combines skill and precision to produce strong, reliable, and high-quality metalwork every time.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    ),
  },
  {
    name: 'Structural Steel',
    desc: 'From basic steel components to complex structural frameworks, we handle all types of structural steelwork for your project.\nOur team ensures strong, accurate, and reliable construction solutions from start to finish.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="9" width="20" height="6" rx="1" />
        <path d="M7 9V6M17 9V6M7 18v-3M17 18v-3" />
      </svg>
    ),
  },
  {
    name: 'Architectural Landscape Products',
    desc: 'We create custom architectural steel products for outdoor spaces, working with designers and contractors on landscape and rooftop projects.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="7" width="20" height="3" rx="1" />
        <rect x="2" y="14" width="20" height="3" rx="1" />
        <line x1="6" y1="7" x2="6" y2="17" />
        <line x1="18" y1="7" x2="18" y2="17" />
      </svg>
    ),
  },
  {
    name: 'Staircases',
    desc: 'We design, fabricate, and install custom steel staircases for residential and commercial projects, combining functionality with modern design and long-lasting quality.',
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="4 20 4 14 10 14 10 9 16 9 16 4 20 4" />
        <line x1="4" y1="20" x2="20" y2="20" />
      </svg>
    ),
  },
  {
    name: 'Mobile Welding',
    desc: 'We offer fast and reliable mobile welding services, bringing professional welding and steel repair work directly to your site.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z" />
        <path d="M7 12l3 3 7-7" />
      </svg>
    ),
  },
  {
    name: 'Steel Supply',
    desc: 'Reliable supply of high-quality steel materials for projects of all sizes.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
  },
  {
    name: 'Steel Beams',
    desc: 'Precision steel beam solutions for strong and dependable structural support.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="9" width="20" height="6" rx="1" />
        <path d="M7 9V6M17 9V6M7 18v-3M17 18v-3" />
      </svg>
    ),
  },
  {
    name: 'Steel Columns',
    desc: 'Fabricated steel columns designed for strength, stability, and accuracy.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="10" y="2" width="4" height="20" rx="1" />
        <rect x="7" y="2" width="10" height="3" rx="1" />
        <rect x="7" y="19" width="10" height="3" rx="1" />
      </svg>
    ),
  },
  {
    name: 'Design',
    desc: 'Practical and buildable steel design solutions tailored to project requirements.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M2 20h20M6 20V10l6-7 6 7v10" />
        <path d="M10 20v-5h4v5" />
      </svg>
    ),
  },
  {
    name: 'Steel Connections',
    desc: 'Accurate steel connection fabrication for safe and secure assembly.',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
        <path d="M16.24 7.76a6 6 0 0 1 0 8.49M7.76 7.76a6 6 0 0 0 0 8.49" />
      </svg>
    ),
  },
  {
    name: 'Steel Sections',
    desc: 'Supply and fabrication of steel sections to meet exact project specifications.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <rect x="8" y="8" width="8" height="8" rx="1" />
      </svg>
    ),
  },
  {
    name: 'Site Surveys',
    desc: 'On-site surveys to assess dimensions, requirements, and installation planning.',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    name: 'Gates',
    desc: 'Custom steel gates built for security, durability, and modern appearance.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="1" y="5" width="22" height="14" rx="2" />
        <line x1="12" y1="5" x2="12" y2="19" />
        <path d="M4 10h4M4 14h4M16 10h4M16 14h4" />
      </svg>
    ),
  },
  {
    name: 'Balustrades',
    desc: 'Architectural steel balustrades designed for safety and clean finishes.',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="2" y1="6" x2="22" y2="6" />
        <line x1="2" y1="18" x2="22" y2="18" />
        <line x1="5" y1="6" x2="5" y2="18" />
        <line x1="10" y1="6" x2="10" y2="18" />
        <line x1="15" y1="6" x2="15" y2="18" />
        <line x1="20" y1="6" x2="20" y2="18" />
      </svg>
    ),
  },
  {
    name: 'Mezzanines',
    desc: 'Strong mezzanine steel structures designed to maximise internal space.',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="7" width="20" height="3" rx="1" />
        <rect x="2" y="14" width="20" height="3" rx="1" />
        <line x1="6" y1="7" x2="6" y2="17" />
        <line x1="18" y1="7" x2="18" y2="17" />
      </svg>
    ),
  },
  {
    name: 'Railing',
    desc: 'Durable steel railing solutions for residential, commercial, and outdoor use.',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="6" y1="6" x2="6" y2="20" />
        <line x1="12" y1="6" x2="12" y2="20" />
        <line x1="18" y1="6" x2="18" y2="20" />
        <line x1="3" y1="20" x2="21" y2="20" />
      </svg>
    ),
  },
  {
    name: 'Welding',
    desc: 'Professional welding services for fabrication, repairs, and on-site work.',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 3l8 4v5c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V7l8-4z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07, delayChildren: 0.1 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1] } },
};

function accentForService(name) {
  const file = SERVICE_ACCENT_FILES[name];
  return file ? imagePath(file) : null;
}

const iconByName = Object.fromEntries(services.map((s) => [s.name, s.icon]));

export default function Services({ section }) {
  const eyebrow = section?.eyebrow || 'What We Do';
  const title = section?.title || 'Our Services';
  const subtitle =
    section?.subtitle ||
    'London-based structural steel, architectural metalwork, staircases, and on-site welding — precision fabrication from design to installation.';

  const items =
    section?.items?.length > 0
      ? section.items.map((s) => ({
          name: s.name,
          desc: s.description || s.desc,
          accentImageUrl: s.accentImageUrl || null,
        }))
      : services.map((s) => ({ name: s.name, desc: s.desc, accentImageUrl: null }));

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services-header">
          <div>
            <div className="eyebrow">{eyebrow}</div>
            <h2 className="section-title">{title}</h2>
            <p className="section-sub">{subtitle}</p>
          </div>
          <div className="services-count">{String(items.length).padStart(2, '0')}</div>
        </div>

        {/*
          Photo accents: map service names → filenames in SERVICE_ACCENT_FILES (siteImages.js).
        */}
        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
        >
          {items.map((svc, i) => {
            const accentUrl = svc.accentImageUrl || accentForService(svc.name);
            return (
              <motion.div
                key={svc.name}
                className={`service-card${accentUrl ? ' service-card--accent' : ''}`}
                variants={cardVariants}
              >
                {accentUrl && (
                  <div
                    className="service-accent-bg"
                    style={{ backgroundImage: `url("${accentUrl}")` }}
                    aria-hidden
                  />
                )}
                <div className="service-num">{String(i + 1).padStart(2, '0')}</div>
                <div className="service-icon">{iconByName[svc.name] || services[0].icon}</div>
                <div className="service-name">{svc.name}</div>
                <div className="service-desc">{svc.desc}</div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
